/* eslint-disable max-len */
/* eslint-disable fp/no-mutating-methods */
import { Swiper, SwiperSlide } from 'swiper/react'
import { Keyboard, Mousewheel, Navigation, Pagination } from 'swiper'
import Typography from '@mui/material/Typography'

import { sort, splitEvery } from 'ramda'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import {
  selectCourseById,
  selectCompletedClasses,
  selectClassesByCourseID,
  fetchCompletedClasses,
} from 'src/v3/self-paced/self-paced.slice'
import { useNavigate, useParams } from 'react-router-dom'
import { ReactElement, useEffect } from 'react'
import { useMediaQuery } from '@mui/material'
import noop from 'src/utilities/noop'

let diff = (a: any, b: any) => a.sequence - b.sequence

export default (): ReactElement => {
  let { courseId } = useParams()
  let navigate = useNavigate()
  let dispatch = useAppDispatch()

  let course = useAppSelector(selectCourseById(courseId ?? ''))
  let classes = useAppSelector(selectClassesByCourseID(courseId ?? ''))
  let completedClasses = useAppSelector(selectCompletedClasses)
  let largeScreen = useMediaQuery('(min-width:1000px)')

  useEffect(() => {
    dispatch(fetchCompletedClasses())
  }, [])

  useEffect(() => {
    if (classes.length === 1) {
      navigate(`/classroom/${courseId}/${classes[0].id}`, { replace: true })
    }
  }, [classes])

  return (
    <>
      <div
        style={{
          minWidth: '100%',
          background: 'url(/banner.png)',
          minHeight: '200px',
          backgroundPosition: '0px 48%',
          backgroundSize: 'cover',
        }}
        className="flex flex-wrap justify-center align-content-center"
      >
        <Typography
          variant="h4"
          style={{ color: 'white', fontFamily: 'smileAndWave' }}
        >
          {course?.name}
        </Typography>
      </div>
      <div className="mt-4">
        {splitEvery(largeScreen ? 5 : 3, sort(diff, classes)).map(
          (items: any) => (
            <Swiper
              cssMode={true}
              slidesPerView={largeScreen ? 5 : 3}
              spaceBetween={10}
              modules={[Navigation, Pagination, Mousewheel, Keyboard]}
              className="netflix-slider"
            >
              {items.map((item: any) => {
                let cls = classes.find((c) => c.id === item.id)
                let isCompleted = completedClasses.some((c) => c === item.id)
                // TODO: This needs to reflect the index of the class - which is in the model yet
                let isNext = completedClasses.some(
                  (c) =>
                    c ===
                    classes.find((x) => x.sequence === item.sequence - 1)?.id,
                )
                let isFirst =
                  classes.find((c) => c.sequence === 0)?.id === item.id
                let enabled = isCompleted || isNext || isFirst
                return (
                  <SwiperSlide key={item.id}>
                    <img
                      style={{
                        cursor: enabled ? 'pointer' : 'not-allowed',
                        filter: enabled
                          ? 'brightness(100%)'
                          : 'brightness(30%)',
                      }}
                      onClick={
                        enabled
                          ? () => navigate(`/classroom/${courseId}/${cls?.id}`)
                          : noop
                      }
                      src={`${import.meta.env.VITE_CLOUDFRONT_URL}/public/${cls?.imageName}`}
                    />
                  </SwiperSlide>
                )
              })}
            </Swiper>
          ),
        )}
      </div>
    </>
  )
}
